var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["badges/heart.j2"] = require( "badges/heart.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-heart-toggle.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<span class=\"c-ugc-tile__heart ";
if(runtime.contextOrFrameLookup(context, frame, "displayHearts")) {
output += " js-heart-toggle ";
;
}
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"hearted")) {
output += "is-hearted ";
;
}
output += "\" ";
output += runtime.suppressValue((lineno = 0, colno = 114, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",(lineno = 0, colno = 126, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"])),"ugc heart"])), env.opts.autoescape);
output += ">\n\n    ";
env.getTemplate("badges/heart.j2", false, "core/templates/contentful/ugc-heart-toggle.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n</span>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-heart-toggle.j2"] , dependencies)